import {MeshButtonDBType, MeshButtonType} from "../../components/annotations/ts/ButtonsTypes";
import * as THREE from "three";

export const  MeshButtonsDB: Array<MeshButtonDBType> = [

    {
        button_id: 'TAN_TAN_P321',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },
    {
        button_id: 'TAN_TAN_P338',
        meshButtonType: MeshButtonType.BasicMeshButton,
        useOutliner: true,
        // outlinerColor: new THREE.Color(0x0000FF),
        outlinerColor: new THREE.Color(0xFFFFFF),
    },

    // {
    //     button_id: 'TAN_TAN_P333',
    //     meshButtonType: MeshButtonType.BasicMeshButton,
    //     useOutliner: true,
    //     // outlinerColor: new THREE.Color(0x0000FF),
    //     outlinerColor: new THREE.Color(0xFFFFFF),
    // },
]
